import {css, type Theme} from '@emotion/react';
import {configureFonts, getFontThemeList} from '@nfq/next-fonts';
import {createConfig} from '@nfq/react-grid';

import {globalCss, shadows, themeColors} from 'UI/utils/theme';

export const fontDefinitions = configureFonts({
    NotoSerif: [
        {
            fontDisplay: 'swap',
            fontStyle: 'normal',
            fontWeight: 'bold',
            preload: true,
            src: '/fonts/noto-serif-bold.woff2'
        },
        {
            fontDisplay: 'swap',
            fontStyle: 'normal',
            fontWeight: 'normal',
            preload: false,
            src: '/fonts/noto-serif-regular.woff2'
        }
    ],
    PlusJakartaSans: [
        {
            fontDisplay: 'swap',
            fontStyle: 'normal',
            fontWeight: 'normal',
            preload: true,
            src: '/fonts/plus-jakarta-sans-regular.woff2'
        },
        {
            fontDisplay: 'swap',
            fontStyle: 'normal',
            fontWeight: '500' as const,
            preload: true,
            src: '/fonts/plus-jakarta-sans-medium.woff2'
        },
        {
            fontDisplay: 'swap',
            fontStyle: 'normal',
            fontWeight: '600' as const,
            preload: true,
            src: '/fonts/plus-jakarta-sans-semibold.woff2'
        },
        {
            fontDisplay: 'swap',
            fontStyle: 'normal',
            fontWeight: 'bold',
            preload: true,
            src: '/fonts/plus-jakarta-sans-bold.woff2'
        },
        {
            fontDisplay: 'swap',
            fontStyle: 'normal',
            fontWeight: '800' as const,
            preload: false,
            src: '/fonts/plus-jakarta-sans-extrabold.woff2'
        }
    ]
});

export const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'] as const;
export const {configType, globalCss: globalGridCss} = createConfig(breakpoints, {
    baseSpacing: 0.4,
    container: {
        xs: 'fluid',
        sm: 'fluid',
        md: 'fluid',
        lg: 'fluid',
        xl: 1140,
        xxl: 1140
    }
});

export const theme: Theme = {
    boxShadows: shadows,
    colors: themeColors,
    fonts: getFontThemeList(fontDefinitions)
};

export const globals = css`
    ${globalCss}

    ${globalGridCss}

    *,
    &::before,
    &::after {
        box-sizing: border-box;
    }

    * {
        -webkit-tap-highlight-color: transparent;
    }

    html {
        font-size: 10px;
    }

    html, body {
        background-color: ${themeColors.surfaceBackground};
        color: ${themeColors.inkPrimary};
        font-family: ${theme.fonts.PlusJakartaSans};
        margin: 0;
        min-height: 100%;
        padding: 0;
        scroll-behavior: smooth;
    }

    #__next {
        min-height: 100%;
    }
`;